import { render, staticRenderFns } from "./SimpleContract.vue?vue&type=template&id=6515ba66&scoped=true&"
import script from "./SimpleContract.vue?vue&type=script&lang=js&"
export * from "./SimpleContract.vue?vue&type=script&lang=js&"
import style0 from "./SimpleContract.vue?vue&type=style&index=0&id=6515ba66&lang=scss&scoped=true&"
import style1 from "./SimpleContract.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515ba66",
  null
  
)

export default component.exports